import React from "react";
import { Navigate } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import { useAuth } from "../lib/authContext";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Dashboard from "../pages/dashboard/page";
import NewRecord from "../pages/new-record/page";
import EditRecord from "../pages/edit-record/page";
import Analytics from "../pages/analytics/page";
import AdminPanel from "../pages/admin/page";
import Appointments from "../pages/appointments/page";
import PricingAdmin from "../pages/pricing/page";
import CariPanel from "../pages/cari/page";
import CalendarPage from "../pages/calendar/page";
import AuthPage from "../pages/auth/page";
import MigrationPage from "../pages/migration/page";
import SmsTemplatesPage from "../pages/sms-templates/page";

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-slate-400 text-sm">Yükleniyor...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return <>{children}</>;
}

function guard(el: React.ReactNode) {
  return <AuthGuard>{el}</AuthGuard>;
}

const routes: RouteObject[] = [
  { path: "/auth", element: <AuthPage /> },
  { path: "/", element: guard(<Home />) },
  { path: "/dashboard", element: guard(<Dashboard />) },
  { path: "/new-record", element: guard(<NewRecord />) },
  { path: "/edit-record/:id", element: guard(<EditRecord />) },
  { path: "/analytics", element: guard(<Analytics />) },
  { path: "/admin", element: guard(<AdminPanel />) },
  { path: "/appointments", element: guard(<Appointments />) },
  { path: "/pricing", element: guard(<PricingAdmin />) },
  { path: "/cari", element: guard(<CariPanel />) },
  { path: "/calendar", element: guard(<CalendarPage />) },
  { path: "/migration", element: guard(<MigrationPage />) },
  { path: "/sms-templates", element: guard(<SmsTemplatesPage />) },
  { path: "*", element: <NotFound /> },
];

export default routes;
